import * as React from 'react';
import { browserHistory } from 'react-router';

const BackButton = () => {
  const backButtonStyle: React.CSSProperties = {
    padding: '12px 20px', // Increased padding for a larger button
    margin: '20px 0',
    backgroundColor: '#4F946A',
    color: '#ffffff', // White text for contrast
    border: 'none', // Removing the border for a cleaner look
    borderRadius: '8px', // Slightly larger radius for a modern, rounded look
    cursor: 'pointer',
    transition: 'all 0.3s ease', // Smooth transition for all hover effects
    fontSize: '16px', // Larger font size for readability
    fontWeight: 'bold', // Bold font weight for emphasis
    textShadow: '0 1px 1px rgba(0, 0, 0, 0.2)', // Subtle text shadow for depth
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)', // Soft shadow for 3D effect
    ':hover': {
      backgroundColor: '#00743F', // Darker shade of blue on hover for interaction feedback
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)', // Enhanced shadow on hover for a lifting effect
    },
  };

  return (
    <button className="basicBackButton" style={backButtonStyle} onClick={() => browserHistory.goBack()}>
      &lt; Back
    </button>
  );
};

export default BackButton;
